import { AddFileFormSectionIds, type FileFormScroller as AddFileFormScroller } from '@/company-portal/add-file/add-file.types';
import { scrollToElement } from '@/shared/utils/browser';

const scrollToSection = (sectionId: AddFileFormSectionIds) => {
    requestAnimationFrame(() => {
        scrollToElement(document.getElementById(sectionId));
    });
};

export const useAddFileFormScroller = (): AddFileFormScroller => ({
    scrollToClientSection: () => scrollToSection(AddFileFormSectionIds.CLIENTS),
    scrollToDocumentSection: () => scrollToSection(AddFileFormSectionIds.DOCUMENTS),
    scrollToErrorSection: () => scrollToSection(AddFileFormSectionIds.ERROR_BANNER),
});
